import { render, staticRenderFns } from "./PassengerEditor.vue?vue&type=template&id=4d84c962&scoped=true"
import script from "./PassengerEditor.vue?vue&type=script&lang=js"
export * from "./PassengerEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d84c962",
  null
  
)

export default component.exports